export const tPremiaWhite = '#FFFFFF';
export const tPremiaGris99 = '#F2F4FA';
export const tPremiaGris90 = '#e4e9f1';
export const tPremiaGris40 = '#4D4F5D';
export const tPremiaMexicanRose = '#FF1C72';
export const tPremiaMexicanRose30 = '#CC165B';
export const tPremiaGreen = '#5DD53C';
export const tPremiaYellow= '#DEBC0B';
export const tPremiaTurquoise = '#183744';
export const headings = 'rgba(255, 255, 255, 0.90)';
export const paragraphs = 'rgba(255, 255, 255, 0.70)';
export const tPremiaAppBG =  '#0A141A4D';
export const tPremiaDarkGrayBlue= '#17242B';
export const appBg = '#0A0C0F';
export const contentBg = 'rgba(23, 36, 43, 0.50)';
export const textColorsNeutral = 'rgba(255, 255, 255, 0.50)';
export const muted = '#FFFFFF33';
export const warning = '#F5993E';
export const tPremiaLightOrange = '#F5993E';
